import React, {useEffect, useState} from 'react';
import {Route, Switch, useHistory, useLocation, useParams} from 'react-router-dom';
import {useFormikContext, Form} from 'formik';

import {useToast,useModal,useFetch} from 'helpers/hooks';
import {Accounting} from 'components/Accounting';

import {Costs} from 'components/Costs';
import {General} from 'components/General';
import {HistoryTable} from 'components/HistoryTable';
import {MetadataTable} from 'components/MetadataTable';
import {Payment} from 'components/Payment';
import {Supplier} from 'components/Supplier';

import {nullifyEmptyValues, stringifyNullValues, request} from "../helpers/tools";
import {InfoModal} from "./InfoModal";
import {LoadTemplateModal} from "./LoadTemplateModal";
import {LoadAIModal} from "./LoadAIModal";

import {FvyModal} from "./FvyModal";

export const EditForm = (
    {
        innerRef,initialValues,
           accountCode, accountingYears, accounts, activities, centres, clientCompanies, contracts, countries, currencies,
        detail, doc, docTypes, isAccountant, isCashDeskDocType, numSeries, paymentTypes, permissions, requiredFields,
        taxRates, vatClassification, vatKvClassification, user, setDuplicates, update, focusedDocId, setFocusedDocId,docCustomType,setDocCustomType,setNoteChanged,setSaving, setSaveButtonTitle
    }
    ) =>
        {
        const excludedKeys = [ 
            //"accounting_year",
            //"document_identifier",
            "state",
            "number",
            "date",
            "due_date",
            "accounting_date",
            "variable_symbol",
            "taxable_supply_date",
            "tax_deduction_date",
            "payment_date",
            "version_id",
            "document_id",
            "id",
            "template_name"]        
        
        
        const checkCurrencyChanges = ()=>{ // if currency was set before, don't auto set euros for slovaks
            let flag = false;
            const log = detail.history;
            
            log.forEach(el => {
                if(Array.isArray(el.data)){
                    if(flag){ return flag;}

                    el.data.forEach(subel => {
                        if(subel[0] === 'Měna' || subel[0] === 'Currency'){
                            flag = true;
                            return true;
                        }
                    })

                }
            });
            return flag;
        }
        
        const [loadTemplateModal, toggleLoadTemplateModal] = useModal();
        const [loadAIModal, toggleLoadAIModal] = useModal();
        const [infomodal, toggleinfomodal] = useModal();

        const [handlySetCurrency, setHandlySetCurrency] = useState(checkCurrencyChanges);
        //const [noteChanged, setNoteChanged] = useState(false);
        const [submitCheck, setSubmitCheck] = useState(0);
        const [initCheck, setInitCheck] = useState(0);
        const [steps, setSteps] =
            useState(['general', 'supplier', 'payment', 'costs', 'accounting', 'history', 'metadata']);

        const [fvymodal, togglefvymodal] = useModal();
        const [fvymodalshown, setfvymodalshown] = useState(false);
   
        
        
        const history = useHistory();
        const location = useLocation();
        const modify = location.pathname.split("/")[2] === "modify";
        const {table} = useParams();
        const [accountingYear, setAccountingYear] = useState(0);
        const [currentCountry, setCurrentCountry] = useState("");

        let  {errors, submitCount, values,validateForm} = useFormikContext(); //isSubmitting,
        if (initCheck===0){
            validateForm()
            setInitCheck(1)
        }

               
        
        let [docTypeToSave, setdocTypeToSave] = useState('');
        function handleCustomTypeSave (type){
            setdocTypeToSave (type)
        }
        
        let [differencesFromTemplateLoad, setdifferencesFromTemplateLoad] = useState([]);

        const templates = useFetch(`/my_templates/?search=&active_only=false&page=1&limit=200`, null)

        const showToast = useToast();

        useEffect(() => { // remove accounting from steps for arrow navigation if user is not accountant
            setSteps(steps => [...steps.slice(0, 4), isAccountant ? 'accounting' : null, ...steps.slice(5)])
        }, [isAccountant, setSteps]);


        useEffect(() => { // navigate between steps with arrows
            const lastNonTrailingSlash = (location.pathname.slice(0, -1).lastIndexOf('/'));
            const currentStep = (location.pathname.slice(lastNonTrailingSlash + 1));
            const baseUrl = location.pathname.slice(0, lastNonTrailingSlash + 1);
            const currentSteps = steps.filter(step => step != null);
            const currentStepIndex = currentSteps.indexOf(currentStep);
            const handleKeyDown = event => {
                if (document.activeElement.tagName !== 'INPUT') {
                    if (event.key === 'ArrowRight' && currentStepIndex < currentSteps.length - 1) {
                        history.push(baseUrl + (currentSteps[currentStepIndex + 1]))
                    } else if (event.key === 'ArrowLeft' && currentStepIndex > 0) {
                        history.push(baseUrl + (currentSteps[currentStepIndex - 1]))
                    }
                }
            };
            window.addEventListener('keydown', handleKeyDown);
            return () => window.removeEventListener('keydown', handleKeyDown);
        }, [location, history, steps]);

        useEffect(() => {
            if (submitCount > submitCheck) {
                if (errors.info) {
                    //toggleinfomodal()
                    //showToast('Opravte prosím chyby ve formuláři');
                    setSubmitCheck(submitCount);
                }
                if (errors.costs) {
                    showToast('Náklady obsahují údaje v nesprávném formátu');
                    setSubmitCheck(submitCount);
                }
            }
        }, [errors.costs, errors.info, showToast, submitCheck, submitCount]);
    
        const editable = (doc.is_active && !doc.awaiting_capture && permissions.edit)||  location.pathname.split("/")[1]==="my_templates" ||  location.pathname.split("/")[2]==="modify";

        function handleLoadTemplate  () {
            toggleLoadTemplateModal()
        }

        function handleLoadAI  () {
            toggleLoadAIModal()
        }

        const preProcessCosts = (costs) => {
            let processed_costs = [];
            costs.forEach((c)=>{
                let itemsassigned = sessionStorage.getItem("itemsassigned"+c.id)
                
                if( //cost is non zero or cost has items that add up to zero
                    (c.value_original !== '' ) || //&& c.value_original && parseFloat(c.value_original)!==0) ||
                    (parseInt(itemsassigned) && parseInt(itemsassigned)>0) ) {
                        if (c.tax_rate && parseInt(c.tax_rate) ){
                            processed_costs.push(c);
                        }
                }
                else{
                    //console.log('invalid cost')
                }
            })
            return processed_costs;
       
        }

        const preProcessItems = (values) => {
            let processed_items = [];
            
            values.items?.forEach((i)=>{
                
                if (!i["centre"]){i["centre"] = values.info["centre"]}
                if (!i["vat_classification"]){i["vat_classification"] = values.info["vat_classification"]}
                if (!i["vat_kv_classification"]){i["vat_kv_classification"] = values.info["vat_kv_classification"]}
                if (!i["reverse_charge"]){i["reverse_charge"] = values.info["reverse_charge"]}
                if (!i["contract"]){i["contract"] = values.info["contract"]}
                if (!i["activity"]){i["activity"] = values.info["activity"]}
                if (!i["account_code"]){i["account_code"] = values.info["account_code"]}
                if (!i["expiration_date"]){i["expiration_date"] = null}

                if (!i["cost"] || !i["cost"]===''){
                    //i["id"] = undefined
                }

                if (i.text !== '' && i.text.length>80){
                    i.text = i.text.substring(0, 76) + '...'
                }
                if(i.text === ''){i.text = 'Položka '+ (processed_items.length+1);}


                if( i.price_original!=='' && i.price_unit!=='') { //everything filled in
                    
                    if (i.quantity===""){i.quantity = 1}
                    
                    i.price_vat = parseFloat(i.price_vat).toFixed(2)
                    i.price_original = parseFloat(i.price_original).toFixed(2)
                    i.price_final = parseFloat(parseFloat(i.price_original).toFixed(2)+parseFloat(i.price_vat).toFixed(2)).toFixed(2)
                    i.price_unit = parseFloat(i.price_unit).toFixed(2)//parseFloat(i.price_original/parseFloat(i.quantity)).toFixed(2)
                   
                    processed_items.push(i);
                }
                
            })
            return processed_items;
        }


        const sumAssignedItems = (cost) => {
            let sumOriginal = 0;
            values.items?.filter( item => parseInt(item.tax_rate) === parseInt(cost.tax_rate)).forEach(item=> sumOriginal += parseFloat(item.price_original) )
            sumOriginal = parseFloat(sumOriginal)

            const taxrate = parseFloat( taxRates?.find(rate => rate.id === parseInt(cost.tax_rate))?.rate);
            cost.value_original = sumOriginal;
            cost.tax = sumOriginal * taxrate/100;
            cost.value_final = sumOriginal + sumOriginal * taxrate/100
        }

        const handleUnfilledCosts = () => {
            values.costs?.filter(cost => cost.value_final==='').forEach(cost =>  sumAssignedItems(cost))
        }

        
        const getSimilarKeysInDicts = (databaseDict, values) =>{
            let diffs = []
            const ignoredKeys = ["tax_rate","rounding"]
            for (var i = 0; i < Object.keys(databaseDict).length; i++) {
                let key = Object.keys(databaseDict)[i]
                
                if (key in values && key in databaseDict && !ignoredKeys.includes(key)){
                    let val1 = databaseDict[key]
                    let val2 = values[key]

                    if (val1 === null || val1 === undefined){val1 = ''}
                    if (val2 === null || val2 === undefined){val2 = ''}

                    if (key === "reverse_charge" ){
                        if (val1 === '' ){val1 = false}
                        if (val2 === '' ){val2 = false}
                    }
                    
                    
                    if (val1 !== val2){
                        if (!['accounting_year'].includes(key)){
                            console.log('DIFFERENCE in ' + key +' init:' + val1 + ' curr  ' + val2)    
                            diffs.push(key)
                        }
                    }
                    else{
                        //console.log('OK '  + key +' ' + val1 + '  ' + val2)    
                    }
                }
                else{
                    //console.log(key+'  not present in both')
                }
            }
           
            return diffs
        }
        
        
        const objectsEqual = (values,formInitValues) => {
            let differences = differencesFromTemplateLoad
            let initVals = formInitValues
            
            differences = getSimilarKeysInDicts(JSON.parse(sessionStorage.getItem("initInfo")), {...values.info})
            
            differencesFromTemplateLoad.forEach(item => {
                differences.push(item);
            });
            
            let d_costs = false
            if ([...initVals["costs"]].filter(cost => cost.hasOwnProperty('id')).length === [...values.costs].length ){
                for(let i =0; i<[...values.costs].length; i++){
                        if (getSimilarKeysInDicts([...initVals["costs"]][i], [...values.costs][i]).length>0){
                           d_costs = true
                        }
                }
            }
            else{d_costs = true}
           
            let d_items = false
            if ([...initVals["items"]].length === [...values.items].length ){
                for(let i =0; i<[...values.items].length; i++){
                        if (getSimilarKeysInDicts([...initVals["items"]][i], [...values.items][i]).length>0){
                            d_items = true
                        }
                }
            }
            else{d_items = true}
            //if (d_items===true){d_costs = true}
            
            let initCostSum = (sessionStorage.getItem("initCostSum"))
            let finalCostSum =(values.costs.reduce((sum, cost) => sum + (cost.value_final || 0), 0))
            if (values.costs.length===0){finalCostSum=0}

            console.log(initCostSum, finalCostSum)
            if (parseInt(initCostSum) === parseInt(finalCostSum)){
                d_costs=false
            }


            if (d_costs===true){differences.push("costs")}
            if (d_items===true){differences.push("items")}

            return  Array.from(new Set(differences));
        }

        const isSaveNeeded = (formInitValues) => {
            let differences = objectsEqual(values,formInitValues)
            if (sessionStorage.getItem("shouldCheckIsSaveNeeded") === "false"){
                sessionStorage.setItem("shouldCheckIsSaveNeeded","true") 
                return differences = []
            }
            if (!location.pathname.includes("my_documents")){
                return differences.filter(item => item === "note");
            }
            

            let valuesunchanged = differences.length === 0 ? true : false
            
            if (valuesunchanged === false){
                sessionStorage.setItem("saverequired", "1");
                sessionStorage.setItem("differences", JSON.stringify(differences));
            }
            else{
                sessionStorage.setItem("saverequired", "0");
                sessionStorage.setItem("differences", "");
            } 
            //console.log("differences")
            //console.log(differences)


            let countrySlug = ''
            const companyIdToSearch = parseInt(values.info["client_company"])
            if (companyIdToSearch){
                const foundCompany = clientCompanies.find(company => parseInt(company.id) === parseInt(companyIdToSearch));
                countrySlug = foundCompany ? foundCompany.country.slug : null;
            }
            if (countrySlug==='sk'){
                const index = differences.indexOf("supplier_vat");
                if (index !== -1) {
                    differences.splice(index, 1);
                }
            }

            return differences
        }
    
        

        const correctNullValue = (val) =>{
            if (val !== "" && (val===null || val===undefined)){
                console.log('Tried to save a Null value!')
                val=""
            }
        }

        const correctNullValues = () =>{
            correctNullValue(values.info.centre)
            correctNullValue(values.info.activity)
            correctNullValue(values.info.contract)
        }

        
        const onSaveButtonClick = async (checkDupl)=>{
            if (checkDupl===undefined){checkDupl=true}
            
            let reload = true
            if (String(sessionStorage.getItem('reloadaftersave'))==='false'){
                reload = false
            }
            if (!location.pathname.includes("my_documents") && !location.pathname.includes("my_templates")){
                let note = values.info.note
                values = initialValues
                values.info.note = note
            }
            correctNullValues()
            
            validateForm()
            if (errors.info && errors.info["unknown_rate"]){
                delete errors.info["unknown_rate"]
            }
            if (errors.info && errors.info["supplier_title"]){
                if (values.info.supplier_title !== undefined && values.info.supplier_title !== ""){
                    delete errors.info["supplier_title"]
                }
            }

            if (values.info.document_identifier !== '' &&
                values.info.document_identifier.length>80){
                values.info.document_identifier = values.info.document_identifier.substring(0, 76) + '...'
            }

            if (values.info.supplier_city !== '' &&
                values.info.supplier_city.length>40){
                values.info.supplier_city = values.info.supplier_city.substring(0, 40)
            }
            if (values.info.supplier_street !== '' &&
                values.info.supplier_street.length>60){
                values.info.supplier_street = values.info.supplier_street.substring(0, 60)
            }
            if (values.info.supplier_zip_code !== '' &&
                values.info.supplier_zip_code.length>9){
                values.info.supplier_zip_code = values.info.supplier_zip_code.substring(0, 9)
            }
            if (values.info.supplier_title !== '' &&
                values.info.supplier_title.length>250){
                values.info.supplier_title = values.info.supplier_title.substring(0, 250)
            }

            const companyIdToSearch = parseInt(values.info["client_company"])
            let countrySlug = ''
            if (companyIdToSearch){
                const foundCompany = clientCompanies.find(company => parseInt(company.id) === parseInt(companyIdToSearch));
                countrySlug = foundCompany ? foundCompany.country.slug : null;
            }
            if (countrySlug!=='sk'){
                values.info.supplier_sk_ic_dph=""
            }
            if (countrySlug==='sk'){
             //   values.info.supplier_vat=""
            }

            
            if (parseInt(values.info["payment_type"])===2){
                ["account", "variable_symbol", "supplier_account_number", "supplier_bank_code"].forEach(key => {
                    values.info[key] = "";
                    if (location.pathname.split("/")[2]==="modify"){
                        values.changedValues.push(key)
                    }
                });
                
            }
            if (values.info["document_type"]==="ppr" || values.info["document_type"]==="pvy"){
                ["payment_type","account", "variable_symbol", "supplier_account_number", "supplier_bank_code"].forEach(key => {
                    values.info[key] = "";
                    if (location.pathname.split("/")[2]==="modify"){
                        values.changedValues.push(key)
                    }
                    });
            }
                            
            //take care of empty dates. Set to null so backend is happy
            Object.keys(values.info).forEach(k => k.toLowerCase().includes('date') && values.info[k] === '' && (values.info[k] = null));

            let uuid = doc.uuid;
            
            setSaveButtonTitle('Ukládám...')
            setSaving(true)
            
            handleUnfilledCosts();
            
            let customType = -1
            if (parseInt(docTypeToSave)){
                customType = parseInt(docTypeToSave)
                values.info.document_type = 'rzn'
            }                      
            
            if (preProcessCosts(values.costs).length===0){
                values.info.rounding = 0
            }

            let outputData = {
                ...values,
                costs: nullifyEmptyValues(preProcessCosts(values.costs)),
                items: stringifyNullValues(preProcessItems(values))
            }
            
            if (outputData.info.reverse_charge === '' ){ outputData.info.reverse_charge  = false; }
            
            for (let i = 0; i < outputData.items.length; i++){
                if (outputData.items[i].guarantee === '' ){ outputData.items[i].guarantee = 0; }
                if (outputData.items[i].reverse_charge === '' ){ outputData.items[i].reverse_charge = false; }
                if (outputData.items[i].expiration_date === '' ){ outputData.items[i].expiration_date = null; }
            }

            let abortSave = false
            for (let i = 0; i<outputData.costs.length; i++){
                if (taxRates?.find(rate => rate.id === parseInt(outputData.costs[i].tax_rate))?.slug.endsWith('unknown') ){
                     if (!errors.info){
                        errors.info = {}
                    }
                    errors.info["unknown_rate"] = "Neznámá daňová sazba"
                    break;
                }
            }

            if (sessionStorage.getItem("actionSave")==="true" && sessionStorage.getItem("checkerrors") === "true" && location.pathname.split("/")[2]!=="modify" ){
                if (errors.info &&  Object.keys(errors.info).length>0){
                    toggleinfomodal()
                    console.log(errors.info)
                    sessionStorage.setItem("docerrors", "errors");
                    setSaveButtonTitle('Uložit')
                    setSaving(false)
                    abortSave=true
                    sessionStorage.setItem("actionSave", "")
                    sessionStorage.setItem("stateforduplicatemodal","")
                    return
                }
                sessionStorage.setItem("checkerrors", "false") 
            }
          
            if (!abortSave && sessionStorage.getItem("actionSave")==="true"){
                sessionStorage.setItem("actionSave", JSON.stringify(outputData))
                sessionStorage.setItem("actionSaveUuid", uuid)
                setSaveButtonTitle('Uložit')
                setSaving(false)
                abortSave=true
                return
            }

            if (!abortSave){
                let url = `/detail/${uuid}/?checkCosts=false`
                if (checkDupl===false){
                    url += '&skipDuplicates=false'
                }
                if (sessionStorage.getItem("stateforduplicatemodal")==="forcesave"){
                    url += `&force=true`
                }

                if (location.pathname.split("/")[2]==="modify"){
                    let uuids = JSON.parse(sessionStorage.getItem("bulkDetailModifyUUIDS"))
                    outputData["uuids"] = [...uuids]
                    url= `/save_bulk_modify/`
                }
                
                
                const response = await request(url, 'PUT', outputData);

                if (response){
                    setSaveButtonTitle('Uložit')
                    setSaving(false)
                    //console.log(response)
                    //console.log(sessionStorage.getItem("forceMove"))
                }
                
                
                if ( ([null,""].includes(sessionStorage.getItem("forceMove")) || !sessionStorage.getItem("forceMove") === "0") && response.status === 403 && response.body.length>0) {
                    //console.log("duplicates")
                    if (!(sessionStorage.getItem("stateforduplicatemodal")==="forwarding")&& !(sessionStorage.getItem("stateforduplicatemodal")==="forcesave")){
                        setDuplicates(response.body)
                        abortSave=true
                        sessionStorage.setItem("saved", "duplicates");
                        sessionStorage.setItem("stateforduplicatemodal", "")
                    }
                    else{
                        sessionStorage.setItem("stateforduplicatemodal", "")
                        sessionStorage.setItem("duplicateuuids", JSON.stringify(response.body))
                        return response.body
                    }
                }
                else if (response.ok){
                    if (location.pathname.split("/")[2]==="modify"){
                        showToast('Dokumenty byly uloženy.');
                    }
                    else{
                        showToast('Dokument byl uložen.');
                    }
                    //await new Promise(resolve => setTimeout(resolve, 1000));
                    setNoteChanged(false);
                    update();
                    sessionStorage.setItem("saved", "ok");
                    if (location.pathname.split("/")[2]==="modify"){
                        if (location.pathname.includes("my_documents")){
                            const detail = `/my_documents`;
                            window.location.href = detail
                        }
                        if (location.pathname.includes("my_templates")){
                            const detail = `/my_templates`;
                            window.location.href = detail
                        }
                    }
                    else if (!(sessionStorage.getItem("stateforduplicatemodal")==="forcesave") ){
                        if (reload===true){
                            //console.log('reloading after successfull save')
                            window.location.reload();
                        }
                    }
                    let docsuuids = uuid
                    if (location.pathname.split("/")[2]==="modify"){
                        let uuids = JSON.parse(sessionStorage.getItem("bulkDetailModifyUUIDS"))
                        docsuuids = [...uuids]
                        console.log("modify uuids type")
                    }

                    if (customType>=0){
                        request('/set_user_type_for_documents/', 'POST', {"documents":docsuuids,"user_type": customType});
                    }
                    else{
                        request('/set_user_type_for_documents/', 'POST', {"documents":docsuuids,"user_type": ''});
                    }
                }  
            }
        }

    const handleCancelButtonClick = () => {
        history.push(`/${table}`, {focusedDocId})
    };


            
    innerRef.current={
        isSaveNeeded : isSaveNeeded,
        onSaveButtonClick : onSaveButtonClick,
        handleLoadTemplate : handleLoadTemplate,
        handleCancelButtonClick : handleCancelButtonClick,
        handleLoadAI : handleLoadAI
    }


    const ccDependentKeys = [ 
        "client_company",
        "centre",
        "activity",
        "contract",
        "num_series",
        "vat_classification",
        "vat_kv_classification",
        "account_code"]     
    
    const overwriteKeys = ["document_type", "accounting_year", "reverse_charge"]
    
    let currentCompany = clientCompanies.find(company => parseInt(company.id) === parseInt(values.info["client_company"]));
    let slug = currentCompany ? currentCompany.country.slug : null;
    if (currentCountry!== slug){setCurrentCountry(slug)}

    
    const loadFromTemplate = (overwrite) =>{
        let ignoreYear = !clientCompanies.find(cc => cc.id === values.info["client_company"])

        if (overwrite === true){
            console.log("\n overwritting from template")
        }
        if (overwrite === false){
            console.log("\n filling from template")
        }
        
        let dtemplate = JSON.parse(sessionStorage.getItem("template")) 
        let oldValues = JSON.parse(JSON.stringify(values) )
        
        const countWithNumericOriginal = values.costs.filter(obj => obj.value_original !== "" && obj.value_original !== null && obj.value_original !== undefined).length;

        let changedCC = values.info["client_company"] !== dtemplate.info["client_company"];
        let changedCountry = true
        
        if (clientCompanies.find(cc => cc.id === values.info["client_company"]) && clientCompanies.find(cc => cc.id === dtemplate.info["client_company"])){
            changedCountry = clientCompanies.find(cc => cc.id === values.info["client_company"]).country.title !== clientCompanies.find(cc => cc.id === dtemplate.info["client_company"]).country.title
        }
        else if (clientCompanies.find(cc => cc.id === values.info["client_company"])){
            changedCountry = clientCompanies.find(cc => cc.id === values.info["client_company"]).country.slug!=="cz"
            console.log(clientCompanies.find(cc => cc.id === values.info["client_company"]).country.slug)
            console.log(clientCompanies.find(cc => cc.id === values.info["client_company"]).country.slug!=="cz")
        }
        else if(!clientCompanies.find(cc => cc.id === values.info["client_company"]) && !clientCompanies.find(cc => cc.id === dtemplate.info["client_company"])){
            changedCountry = false
        }

        Object.keys(values.info).forEach((key) => {
            if ( !excludedKeys.includes(key) ) {
                    if (overwrite === true){
                        if (dtemplate.info[key]){
                            console.log("overwriting " +key + " from " + values.info[key] + " -> " +dtemplate.info[key])
                            values.info[key] = dtemplate.info[key];
                            values.changedValues.push(key)
                        }
                    }
                    if (overwrite === false){
                        if (!values.info[key] || overwriteKeys.includes(key) ){
                            if ( !(ccDependentKeys.includes(key) && changedCC===true) || ignoreYear===true ){
                                if (dtemplate.info[key]){
                                    console.log("filling " +key + " from " + values.info[key] + " -> " +dtemplate.info[key])
                                    values.info[key] = dtemplate.info[key];
                                    values.changedValues.push(key)
                                }
                            }
                            else{
                                console.log("keeping " +key + " " + values.info[key] + " because CC cannot change")                
                            }
                        }
                    }

                    if (!values.info[key]) {
                        values.info[key] = "";
                        values.changedValues.push(key)
                    }
            }
            else{
                console.log("keeping " +key + " " + values.info[key] + " because is excluded")
            }
        });
        values.info["template_name"]=""

        let currentCompany = clientCompanies.find(company => parseInt(company.id) === parseInt(values.info["client_company"]));
        let slug = currentCompany ? currentCompany.country.slug : null;
        if (currentCountry!== slug){setCurrentCountry(slug)}
        
        
        if ( (changedCountry===false) && ((countWithNumericOriginal===0) || overwrite === true)){
            console.log("inserting costs")
            values.costs=dtemplate.costs
            values.costs.forEach(i=>{
                i["id"]=undefined
                i["document_id"]=undefined
            })
            console.log("costs")
            console.log(values.costs)

            values.items=[]
            if (dtemplate.items && dtemplate.items.length>0){
                dtemplate.items.forEach(i=>{
                    i["id"]=undefined
                    i["cost_id"]=undefined
                    i["external_id"]=undefined
                    i["document_id"]=undefined
                    if (changedCC===true){
                        ccDependentKeys.forEach(k => {
                            i[k] = undefined
                        })
                    }
                    values.items.push(i)
                })
            }
            console.log("items")
            console.log(values.items)
        }
        if (changedCountry===true){
            showToast("Náklady nebylo možné přenést.")
        }

        let diffs = objectsEqual(values,oldValues)
        setdifferencesFromTemplateLoad(diffs)

        if (overwrite){showToast("Data načtena ze šablony.")}
        else {showToast("Data doplněna ze šablony.")}
    }

    const loadFromAI = (docData,overwrite) =>{
        const dtemplate = docData
        console.log(dtemplate)
        let ignoreYear = !clientCompanies.find(cc => cc.id === values.info["client_company"])

        if (overwrite === true){
            console.log("\n overwritting from template")
        }
        if (overwrite === false){
            console.log("\n filling from template")
        }
        
        
        let oldValues = JSON.parse(JSON.stringify(values) )
        
        const countWithNumericOriginal = values.costs.filter(obj => obj.value_original !== "" && obj.value_original !== null && obj.value_original !== undefined).length;

        let changedCC = values.info["client_company"] !== dtemplate.info["client_company"];
        let changedCountry = true
        if (clientCompanies.find(cc => cc.id === values.info["client_company"]) && clientCompanies.find(cc => cc.id === dtemplate.info["client_company"])){
            changedCountry = clientCompanies.find(cc => cc.id === values.info["client_company"]).country.title !== clientCompanies.find(cc => cc.id === dtemplate.info["client_company"]).country.title
        }
        else if (clientCompanies.find(cc => cc.id === values.info["client_company"])){
            changedCountry = clientCompanies.find(cc => cc.id === values.info["client_company"]).country.slug!=="cz"
            console.log(clientCompanies.find(cc => cc.id === values.info["client_company"]).country.slug)
            console.log(clientCompanies.find(cc => cc.id === values.info["client_company"]).country.slug!=="cz")
        }
        else if(!clientCompanies.find(cc => cc.id === values.info["client_company"]) && !clientCompanies.find(cc => cc.id === dtemplate.info["client_company"])){
            changedCountry = false
        }

        Object.keys(values.info).forEach((key) => {
            if ( !excludedKeys.includes(key) ) {
                    if (overwrite === true){
                        if (dtemplate.info[key]){
                            console.log("overwriting " +key + " from " + values.info[key] + " -> " +dtemplate.info[key])
                            values.info[key] = dtemplate.info[key];
                            values.changedValues.push(key)
                        }
                    }
                    if (overwrite === false){
                        if (!values.info[key] || overwriteKeys.includes(key) ){
                            if ( !(ccDependentKeys.includes(key) && changedCC===true) || ignoreYear===true ){
                                if (dtemplate.info[key]){
                                    console.log("filling " +key + " from " + values.info[key] + " -> " +dtemplate.info[key])
                                    values.info[key] = dtemplate.info[key];
                                    values.changedValues.push(key)
                                }
                            }
                            else{
                                console.log("keeping " +key + " " + values.info[key] + " because CC cannot change")                
                            }
                        }
                    }

                    if (!values.info[key]) {
                        values.info[key] = "";
                        values.changedValues.push(key)
                    }
            }
            else{
                console.log("keeping " +key + " " + values.info[key] + " because is excluded")
            }
        });
        values.info["template_name"]=""

        let currentCompany = clientCompanies.find(company => parseInt(company.id) === parseInt(values.info["client_company"]));
        let slug = currentCompany ? currentCompany.country.slug : null;
        if (currentCountry!== slug){setCurrentCountry(slug)}
        
        
        if ( (changedCountry===false) && ((countWithNumericOriginal===0) || overwrite === true)){
            console.log("inserting costs")
            values.costs=dtemplate.costs
            values.costs.forEach(i=>{
                i["id"]=undefined
                i["document_id"]=undefined
            })
            console.log("costs")
            console.log(values.costs)

            values.items=[]
            if (dtemplate.items && dtemplate.items.length>0){
                dtemplate.items.forEach(i=>{
                    i["id"]=undefined
                    i["cost_id"]=undefined
                    i["external_id"]=undefined
                    i["document_id"]=undefined
                    if (changedCC===true){
                        ccDependentKeys.forEach(k => {
                            i[k] = undefined
                        })
                    }
                    values.items.push(i)
                })
            }
            console.log("items")
            console.log(values.items)
        }
        if (changedCountry===true){
            showToast("Náklady nebylo možné přenést.")
        }

        let diffs = objectsEqual(values,oldValues)
        setdifferencesFromTemplateLoad(diffs)

        if (overwrite){showToast("Data načtena z AI návrhu.")}
        else {showToast("Data doplněna z AI návrhu.")}
    }



    let accYear =  accountingYears?.find(y => y.id === parseInt(values.info["accounting_year"]))
    if (accYear && accountingYear !== accYear.year){
        setAccountingYear(accYear.year)
    }
    sessionStorage.setItem("accountingYears", JSON.stringify(accountingYears))
      
       //console.log(detail.info.supplier_identification_number)
       //console.log(detail.info.supplier_vat)
       //console.log(doc.captured_from_isdoc)
       let switchToFvy = false
       try {
           switchToFvy = doc.captured_from_isdoc && clientCompanies.find(c => c.id === values.info.client_company).identification_number === detail.info.supplier_identification_number 
       }
       catch{}
       
       useEffect(() => {
           if (switchToFvy && !fvymodalshown) {
               togglefvymodal()
               setfvymodalshown(true)
           }
       }, [switchToFvy, fvymodalshown,togglefvymodal])
   
       const closefvymodal = () => {
           togglefvymodal()
       }
   
       const  setSalesInvoice = async () => {
           togglefvymodal()
           sessionStorage.setItem('reloadaftersave','false')
           onSaveButtonClick(false)
           await new Promise(resolve => setTimeout(resolve, 1000));
           const body = doc.uuid
           const response = await request('/set_sales_invoice/', 'POST', body);
           console.log(response)
           sessionStorage.setItem('reloadaftersave','true')
           window.location.reload();
       }
    return (
        <>
            <Form>
                <Switch>
                    <Route exact path={`/${table}/:uuid/general`}>
                        <General
                            docTypes={docTypes}
                            clientCompanies={clientCompanies}
                            accountingYears={accountingYears}
                            activities={activities}
                            centres={centres}
                            contracts={contracts}
                            editable={editable}
                            doc={doc}
                            isAccountant={isAccountant}
                            isCashDeskDocType={isCashDeskDocType}
                            fetchRequiredFields={requiredFields}
                            noteEditable={permissions.edit}
                            setNoteChanged={setNoteChanged}
                            user={user}
                            handleCustomTypeSave={handleCustomTypeSave}
                            docCustomType={docCustomType}
                            setDocCustomType={setDocCustomType}
                            excludedKeys={excludedKeys}
                            setAccountingYear={setAccountingYear}
                            taxRates={taxRates} 
                            countries={countries}
                            setfvymodalshown={setfvymodalshown}
                            numSeries={numSeries}
                        />
                    </Route>
                    <Route exact path={`/${table}/:uuid/supplier`}>
                        <Supplier
                                doc={doc}
                            user={user} 
                            countries={countries}
                            editable={editable}
                            isAccountant={isAccountant}
                            fetchRequiredFields={requiredFields}
                            clientCompanies={clientCompanies} 
                            excludedKeys={excludedKeys}
                        />
                    </Route>
                    <Route exact path={`/${table}/:uuid/payment`}>
                        <Payment
                            user={user} 
                            paymentTypes={paymentTypes}
                            accounts={accounts}
                            editable={editable}
                            isAccountant={isAccountant}
                            fetchRequiredFields={requiredFields}
                            excludedKeys={excludedKeys}
                            isCashDeskDocType={isCashDeskDocType}
                        />
                    </Route>
                    <Route exact path={`/${table}/:uuid/costs`}>
                        <Costs  taxRates={taxRates} 
                                user={user} 
                                handlySetCurrency={handlySetCurrency} 
                                setHandlySetCurrency={setHandlySetCurrency} 
                                currencies={currencies} 
                                editable={editable} 
                                isAccountant={isAccountant} 
                                log = {detail.history} 
                                docTypes={docTypes}
                                doc={doc}
                                accountingYears={accountingYears}
                                clientCompanies={clientCompanies} 
                                centres ={centres}
                                activities={activities}
                                contracts={contracts}
                                vatClassification={vatClassification}
                                vatKvClassification={vatKvClassification}
                                accountCode={accountCode}
                                excludedKeys={excludedKeys}
                                />
                    </Route>
                    <Route exact path={`/${table}/:uuid/accounting`}>
                                <Accounting
                                    user={user} 
                                    editable={editable}
                                    numSeries={numSeries}
                                    accountCode={accountCode}
                                    vatClassification={vatClassification}
                                    vatKvClassification={vatKvClassification}
                                    accountingYears={accountingYears}
                                    docTypes={docTypes}
                                    fetchRequiredFields={requiredFields}
                                    excludedKeys={excludedKeys}
                                />
                    </Route>
                    <Route exact path={`/${table}/:uuid/history`}>
                        <HistoryTable logs={detail.history}/>
                    </Route>
                    <Route exact path={`/${table}/:uuid/metadata`}>
                        <MetadataTable
                            doc={doc}
                            docTypes={docTypes}
                            clientCompanies={clientCompanies}
                            currencies={currencies}
                            detail={detail}
                            docState={doc.state}
                            externalId={doc.external_id}
                        />
                    </Route>
                </Switch>
              
                
                {modify===true &&
                    <div 
                            style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                        }}
                    >
                    <p style={{ textAlign: 'center', color:"var(--purple)", fontSize: '1.1em' }}>Zvýrazněné změny budou zapsány do zvolených dokladů.</p>
                    </div>
                }
            </Form>
             {fvymodal &&<FvyModal action={setSalesInvoice}  onClose={() => setfvymodalshown(false)} close={closefvymodal}/>}
            {infomodal &&<InfoModal close={toggleinfomodal} errors={errors}/>}
            {(loadTemplateModal) &&<LoadTemplateModal close={toggleLoadTemplateModal} loadFromTemplate={loadFromTemplate} templates={templates} accountingYears={accountingYears}  ignoreYear={!clientCompanies.find(cc => cc.id === values.info["client_company"])} year={accountingYear} user={user}/>}
            {loadAIModal &&<LoadAIModal doc={doc} user={user} loadFromAI={loadFromAI} close={toggleLoadAIModal} docTypes={docTypes} />}
        </>
        )
    }
;